export interface ThemeProps {
    arrowIcon: string;
    content: string;
    floating: {
        animation: string;
        arrow: {
            base: string;
            style: {
                dark: string;
                light: string;
                auto: string;
            };
            placement: string;
        };
        base: string;
        content: string;
        divider: string;
        header: string;
        hidden: string;
        item: {
            container: string;
            base: string;
            icon: string;
        },
        style: {
            dark: string;
            light: string;
            auto: string;
        }
        target: string;
    },
    inlineWrapper: string;
}

export const dropdownTheme: ThemeProps = {
    arrowIcon: 'ml-2 h-4 w-4',
    content: 'py-1 focus:outline-none list-none pl-0 m-0',
    floating: {
        animation: 'transition-opacity',
        arrow: {
            base: 'absolute z-10 h-2 w-2 rotate-45',
            style: {
                dark: 'bg-gray-900 dark:bg-gray-700',
                light: 'bg-white',
                auto: 'bg-white dark:bg-gray-700',
            },
            placement: '-4px',
        },
        base: 'z-10 w-fit divide-y divide-gray-100 rounded shadow focus:outline-none',
        content: 'py-1 text-sm text-gray-700 dark:text-gray-200',
        divider: 'my-1 h-px bg-gray-100 dark:bg-gray-600',
        header: 'block px-4 py-2 text-sm text-gray-700 dark:text-gray-200',
        hidden: 'invisible opacity-0',
        item: {
            container: '',
            base: 'flex w-full cursor-pointer items-center disabled:cursor-not-allowed disabled:hover:bg-transparent disabled:text-gray-300 justify-start px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 focus:bg-gray-100 focus:outline-none dark:text-gray-200 dark:hover:bg-gray-600 dark:hover:text-white dark:focus:bg-gray-600 dark:focus:text-white bg-transparent',
            icon: 'mr-2 h-4 w-4',
        },
        style: {
            dark: 'bg-gray-900 text-white dark:bg-gray-700',
            light: 'border border-gray-200 bg-white text-gray-900',
            auto: 'border border-gray-200 bg-white text-gray-900 dark:border-none dark:bg-gray-700 dark:text-white',
        },
        target: 'w-fit',
    },
    inlineWrapper: 'flex items-center',
};